import { TFunction } from "i18next";

import { Badge, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { NameType } from "@type/inventory/name";
import { IconEdit01, IconTrash01 } from "@pentabd/icons";

export const NameTableColumn = (
  t: TFunction<"translation", undefined>,
  openConfirmationModel: (itemName: string, id: string | number) => void,
  nameFetchByIdActionHandler: (id: string | number) => void,
  handleScrollToTop: () => void,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "nameBn",
      name: t("INVENTORY_SETTINGS.NAME.TABLE_COLUMN.NAME"),
      render: (_: string, row: NameType) => {
        return (
          <div className="d-flex flex-column">
            <Text color="info" weight="bold">
              {language === "bn" ? row.nameBn : row.nameEn}
            </Text>
            <Text color="subtitle1">{row.brand.name || "..."}</Text>
          </div>
        );
      },
    },
    {
      id: 2,
      key: "creationDate",
      name: t("INVENTORY_SETTINGS.NAME.TABLE_COLUMN.GROUP"),
      render: (_: string, row: NameType) => {
        return (
          <Badge
            label={`${row.group.name || "..."}`}
            type="warning"
            className="w-max"
          />
        );
      },
    },

    {
      id: 3,
      key: "type",
      name: t("INVENTORY_SETTINGS.NAME.TABLE_COLUMN.TYPE"),
      render: (type: string) => {
        return (
          <Text color="subtitle1">{type ? type.toUpperCase() : "..."}</Text>
        );
      },
    },
    {
      id: 3,
      key: "inventoryType",
      name: t("INVENTORY_SETTINGS.NAME.TABLE_COLUMN.INVENTORY_TYPE"),
      render: (inventoryType: string) => {
        return (
          <Text color="subtitle1">
            {inventoryType ? inventoryType.toUpperCase() : "..."}
          </Text>
        );
      },
    },
    // {
    //   id: 4,
    //   key: "id",
    //   name: "",
    //   render: (id: number | string, row: NameType) => {
    //     return (
    //       <div
    //         onClick={() => {
    //           openConfirmationModel(row?.nameEn, id);
    //         }}
    //         className="cursor-pointer"
    //       >
    //         <IconTrash01 size={24} fill="danger" />
    //       </div>
    //     );
    //   },
    // },
    {
      id: 3,
      key: "description",
      name: t("INVENTORY_SETTINGS.NAME.TABLE_COLUMN.DESCRIPTION"),
      render: (description: string) => {
        return (
          <Text color="subtitle1">{description ? description : "N/A"}</Text>
        );
      },
    },
    {
      id: 4,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <div
            onClick={() => {
              handleScrollToTop();
              nameFetchByIdActionHandler(id);
            }}
            className="cursor-pointer"
          >
            <IconEdit01 size={24} />
          </div>
        );
      },
    },
  ];
};
